<template>
	<IntersectionRoot
		ref="root"
		class="scroll-to-load"
		:threshold="threshold"
		@scroll="$emit('scroll', $event)"
	>
		<slot />
		<IntersectionChild
			class="scroll-to-load-spinner"
			:class="{ loading }"
			@enter="onEnter"
			@leave="onLeave"
		>
			<slot name="spinner">
				<Spinner />
			</slot>
		</IntersectionChild>
	</IntersectionRoot>
</template>

<script>
import {
	IntersectionRoot,
	IntersectionChild,
} from '@/components/common/Intersection'
import { Spinner } from '@/components/common'
export default {
	name: 'ScrollToLoad',
	components: { IntersectionRoot, IntersectionChild, Spinner },
	emits: ['bottom', 'scroll'],
	props: {
		loading: { type: Boolean, default: null },
		threshold: {
			type: Number,
			default: 0.5,
		},
	},
	methods: {
		onEnter(e) {
			this.$emit('bottom', true)
		},
		onLeave(e) {
			this.$emit('bottom', false)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.scroll-to-load-spinner {
	width: 100%;
	opacity: 0;
	min-height: 1px;
	max-height: 1px;
	transition: all 0.3s linear;
	transition-property: opacity, max-height;
	overflow: hidden;
	@include flex;
	justify-content: center;
	&.loading {
		opacity: 1;
		max-height: 150px;
		height: auto;
		overflow: visible;
	}
}
</style>
